import React from "react";
import { fromPublic } from "../../../../utils";
import { ErrorContainer, InfoText, WarningIcon } from "../styles";

interface WarningStateProps {
  text: string;
  icon: string;
}

const WarningState: React.FC<WarningStateProps> = ({ text, icon }) => (
  <ErrorContainer as="div" style={{ cursor: "default" }}>
    <WarningIcon src={fromPublic(icon)} alt="Warning" />
    <InfoText>{text}</InfoText>
  </ErrorContainer>
);

export default WarningState;
